module.exports = __webpack_public_path__ + "static/media/img-6e049aa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/blewm-logo.png
// module id = 5279
// module chunks = 39